export default __webpack_public_path__ + "static/media/emptyJobsPage.8edcbba0.svg";